/**
 * PDP v2 set row (019 §8, S2), loaded after pdp-v2.js (uses theme.pdpV2); split
 * out for the §11 budget. Renders from Collection Offer state on every trigger
 * (CO.computeState / CO.unitSaving). One set-add POST by the module owner,
 * never retried; only a 2xx with items confirms; tracking after a confirmed
 * POST is independent of rendering.
 */
(function () {
  'use strict';

  var theme = window.theme = window.theme || {};
  var api = theme.pdpV2;
  if (!api || api.__setInitialised) return;
  api.__setInitialised = true;

  var coApi = function () { return theme.collectionOffers || null; };

  /** §8.4 prospective qualification: offer {slot, percentage, min}, CO cart lines, units [{price, compareAt}] per new line. */
  api.setQuote = function (co, offer, cartLines, units) {
    var slot = Number(offer.slot);
    var base = (cartLines || []).slice();
    var added = units.map(function (u) { return { slot: slot, quantity: 1, price: u.price, compareAt: u.compareAt || 0 }; });
    var after = co.computeState([offer], base.concat(added))[slot];
    var before = co.computeState([offer], base)[slot];
    var rows = units.map(function (u) {
      var full = Math.max(Number(u.price) || 0, Number(u.compareAt) || 0);
      var saving = after.qualified ? co.unitSaving(u.price, u.compareAt, offer.percentage) : 0;
      return { price: Number(u.price) || 0, full: full, saving: saving, net: (Number(u.price) || 0) - saving };
    });
    var total = rows.reduce(function (n, r) { return n + r.net; }, 0);
    var was = rows.reduce(function (n, r) { return n + r.full; }, 0);
    return {
      qualified: after.qualified,
      remaining: after.remaining,
      rows: rows,
      total: total,
      was: after.qualified ? was : null,
      save: after.qualified ? was - total : 0,
      bagDrops: after.qualified && !before.qualified && before.existingSaving > 0
    };
  };

  /** §8.4 steps 5 and 6: the pant's set price, and whether the bag plus the pant qualifies. */
  api.pantQuote = function (co, offer, cartLines, pant) {
    var slot = Number(offer.slot);
    var saving = co.unitSaving(pant.price, pant.compareAt, offer.percentage);
    var lines = (cartLines || []).concat([{ slot: slot, quantity: 1, price: pant.price, compareAt: pant.compareAt || 0 }]);
    var withBag = co.computeState([offer], lines)[slot];
    var bagHasSlot = (cartLines || []).some(function (l) { return Number(l.slot) === slot && !l.giftCard && l.quantity > 0; });
    return { saving: saving, setPrice: pant.price - saving, bagQualifies: withBag.qualified && bagHasSlot };
  };

  /** §8.7 drawer-section preflight: hardening 010 §B2, both predicates. */
  api.drawerSectionValid = function (html, liveForm) {
    if (!html || typeof html !== 'string') return false;
    var t = document.createElement('template');
    t.innerHTML = html;
    if (!t.content.querySelector('[data-merge-list="cart-items"]')) return false;
    if (liveForm && liveForm.querySelector('[data-merge="collection-offer-state"]')
      && !t.content.querySelector('[data-merge="collection-offer-state"]')) return false;
    return true;
  };

  var fill = function (template, vars) {
    return String(template || '')
      .replace(/\[(\w+)\]/g, function (m, k) { return Object.prototype.hasOwnProperty.call(vars, k) ? String(vars[k]) : m; })
      .replace(/\{(\w+)\}/g, function (m, k) { return Object.prototype.hasOwnProperty.call(vars, k) ? String(vars[k]) : m; });
  };
  api.fill = fill;

  // ---- the mutation owner: module-scoped, outlives row disconnects (§8.8) ----
  var mutation = api.mutation = api.mutation || { pending: null, lastOutcome: null };

  function sectionTargets() {
    var out = [];
    ['page-header', 'cart-drawer'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el && el.dataset && el.dataset.sectionId) out.push(el);
    });
    return out;
  }

  function refreshHeader() {
    var header = document.querySelector('page-header');
    if (!header || !header.dataset.sectionId) return Promise.resolve();
    var id = header.dataset.sectionId;
    return fetch(location.pathname + '?sections=' + encodeURIComponent(id))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (data && data[id] && typeof header.updateFromCartChange === 'function') header.updateFromCartChange(data[id]);
      })
      .catch(function () {});
  }
  api.refreshHeader = refreshHeader;

  // §8.7 opener order: the set button if connected, a connected row's, the bag link, null.
  function liveOpener(o) {
    return (o && o.isConnected && o) || document.querySelector('pdp-set-row [data-cta]')
      || document.querySelector('page-header a[href$="/cart"]') || null;
  }

  function formatUnit(cents, currency) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  /** §8.9 tracking after a confirmed add, independent of rendering (017 Q1). */
  function trackSet(items, currency) {
    var value = items.reduce(function (n, i) { return n + i.price; }, 0) / 100;
    api.track('pdp_add', { source: 'pdp_set', items_count: items.length, value: value, currency: currency });
    var learnq = window._learnq;
    if (!learnq || typeof learnq.push !== 'function') return;
    fetch(location.origin + '/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      items.forEach(function (i) {
        learnq.push(['track', 'Added to Cart', Object.assign({
          total_price: cart.total_price / 100,
          $value: cart.total_price / 100,
          total_discount: cart.total_discount,
          original_total_price: cart.original_total_price / 100,
          items: cart.items
        }, {
          Name: i.title,
          ProductID: i.productId,
          Categories: i.type ? [i.type] : [],
          ImageURL: i.image || '',
          URL: location.origin + i.url,
          Brand: i.vendor,
          Price: formatUnit(i.price, currency),
          CompareAtPrice: formatUnit(i.compareAt || 0, currency),
          $use_ip: true,
          $is_session_activity: true
        })]);
      });
    }).catch(function () {});
  }
  api.trackSet = trackSet;

  /** §8.7: resolves {kind: 'confirmed'} or {kind: 'unproven', message}; later failures never make it unproven. */
  api.addSet = function (opts) {
    if (mutation.pending) return mutation.pending;
    mutation.lastOutcome = null;
    var targets = sectionTargets();
    var body = {
      items: opts.items.map(function (i) { return { id: Number(i.variantId), quantity: 1 }; }),
      sections: targets.map(function (el) { return el.dataset.sectionId; }).join(','),
      sections_url: location.pathname
    };
    var settle = fetch(theme.routes.cartAdd + '?pdp_source=set', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
      keepalive: true
    }).then(function (res) {
      return res.text().then(function (text) {
        var data = null;
        try { data = JSON.parse(text); } catch (e) { data = null; }
        return { ok: res.ok, data: data };
      }, function () { return { ok: false, data: null }; });
    }, function () {
      return { ok: false, data: null };
    }).then(function (r) {
      // §8.8: complete against the live document; sections may have been replaced meanwhile.
      var drawer = document.querySelector('cart-drawer');
      var header = document.querySelector('page-header');
      var confirmed = r.ok && r.data && Array.isArray(r.data.items);
      if (!confirmed) {
        var message = (r.data && typeof r.data.description === 'string' && r.data.description) || opts.copy.unproven;
        mutation.lastOutcome = { kind: 'unproven', message: message, dismissed: false };
        if (drawer) {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { detail: { opener: liveOpener(opts.opener) } }));
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        } else {
          var co = coApi();
          if (co && typeof co.refresh === 'function') co.refresh();
          if (header) refreshHeader();
        }
        return { kind: 'unproven', message: message };
      }
      try { trackSet(opts.items, opts.currency); } catch (e) { /* tracking never blocks */ }
      mutation.returnFocus = true; // pdp-v2.js returns focus to the row when the drawer closes
      var sections = r.data.sections || {};
      try {
        if (drawer) {
          var dHtml = sections[drawer.dataset.sectionId];
          if (api.drawerSectionValid(dHtml, drawer.querySelector('cart-form'))) {
            drawer.updateFromCartChange(dHtml);
          } else {
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
          }
        } else {
          var co2 = coApi();
          if (co2 && typeof co2.refresh === 'function') co2.refresh();
        }
        if (header) {
          var hHtml = sections[header.dataset.sectionId];
          if (hHtml && typeof header.updateFromCartChange === 'function') header.updateFromCartChange(hHtml);
          else refreshHeader();
        }
        if (drawer && theme.settings && theme.settings.afterAddToCart === 'drawer' && !drawer.hasAttribute('open')) {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { detail: { opener: liveOpener(opts.opener) } }));
        }
      } catch (e) { /* a rendering failure after a confirmed POST is not an unproven add */ }
      return { kind: 'confirmed' };
    }).then(function (outcome) {
      mutation.pending = null;
      return outcome;
    }, function () {
      mutation.pending = null;
      return { kind: 'unproven', message: opts.copy.unproven };
    });
    mutation.pending = settle;
    return settle;
  };

  // ---- <pdp-set-row> ----
  class PdpSetRow extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this.injected = api.isInjected(this);
      if (this.injected) { this.classList.add('is-injected'); return; }
      this.config = api.readIsland(this, 'script[data-set-config]') || {};
      this.form = document.querySelector('.section-main-product > product-form.pdp-v2');
      // A restored snapshot (prefetch cache, back/forward) carries this marker
      // from its previous life; a fresh server render does not (§8.6).
      var restored = this.hasAttribute('data-hydrated');
      this.setAttribute('data-hydrated', '');
      this.state = { tab: this.config.firstTab || 'tops', pieceId: null, pieceVariantId: null };
      var alertEl = this.querySelector('[data-alert]');
      if (alertEl) alertEl.textContent = '';
      var live = this.querySelector('[data-live]');
      if (live) live.textContent = '';

      this._onClick = this.handleClick.bind(this);
      this._onRender = this.render.bind(this);
      this.addEventListener('click', this._onClick);
      document.addEventListener('on:collection-offer:state', this._onRender);
      if (this.form) this.form.addEventListener('on:variant:change', this._onRender);

      // §8.6/§8.8: a snapshot's serialised busy state never survives; derive it from the owner.
      this.setBusy(!!mutation.pending);
      if (!coApi()) { this.hidden = true; return; }
      var self = this;
      if (mutation.pending) mutation.pending.then(function (o) { self.setBusy(false); self.finish(o); });
      this.render();
      this.injectStickyLink();
      if (restored) {
        if (document.querySelector('cart-drawer')) document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        else if (typeof coApi().refresh === 'function') coApi().refresh();
      }
    }

    disconnectedCallback() {
      if (!this._connected) return;
      this._connected = false;
      this.removeEventListener('click', this._onClick);
      document.removeEventListener('on:collection-offer:state', this._onRender);
      if (this.form) this.form.removeEventListener('on:variant:change', this._onRender);
      if (this.stickyLink && this.stickyLink.parentNode) this.stickyLink.parentNode.removeChild(this.stickyLink);
      this.stickyLink = null;
    }

    offer() {
      return { slot: Number(this.config.slot), percentage: Number(this.config.percentage), min: Number(this.config.min) };
    }

    pantUnit() {
      var picker = this.form && this.form.querySelector('variant-picker');
      var data = picker && typeof picker.getVariantData === 'function' ? picker.getVariantData() : null;
      var variants = (data && data.variants) || [];
      var selected = picker && picker.variant ? picker.variant : null;
      var v = selected || variants.find(function (x) { return x.available; }) || variants[0];
      return v ? { id: v.id, price: v.price, compareAt: v.compare_at_price || 0, chosen: !!selected } : null;
    }

    piece() {
      var id = this.state.pieceId;
      return (this.config.pieces || []).find(function (p) { return String(p.id) === String(id); }) || null;
    }

    money(cents) {
      return typeof theme.formatMoney === 'function' ? theme.formatMoney(cents, { currency: this.config.currency }) : String(cents / 100);
    }

    handleClick(evt) {
      var t = evt.target;
      if (!t || !t.closest) return;
      var tab = t.closest('[data-tab]');
      var tile = t.closest('.pdp-v2-set__tile');
      var chip = t.closest('[data-piece-variant]');
      var cta = t.closest('[data-cta]');
      var dismiss = t.closest('[data-dismiss]');
      if (dismiss) {
        if (mutation.lastOutcome) mutation.lastOutcome.dismissed = true;
        this.querySelector('[data-alert]').textContent = '';
        return;
      }
      if (tab) {
        this.state.tab = tab.getAttribute('data-tab');
        this.state.pieceId = null;
        this.state.pieceVariantId = null;
        this.render();
        // §8.11: the tile list updates in place; announce its count politely.
        var shown = this.querySelectorAll('[data-tiles="' + this.state.tab + '"] .pdp-v2-set__tile').length;
        var liveTab = this.querySelector('[data-live]');
        if (liveTab) liveTab.textContent = fill((this.config.copy || {}).tabShown || '{count} shown: {tab}', { count: shown, tab: tab.textContent.trim() });
      } else if (tile) {
        var id = tile.getAttribute('data-piece');
        var same = String(this.state.pieceId) === String(id);
        this.state.pieceId = same ? null : id;
        this.state.pieceVariantId = null;
        if (!same) api.track('set_item_select', { piece_product_id: String(id), tab: this.state.tab });
        this.render();
        var keep = this.querySelector('.pdp-v2-set__tile[data-piece="' + id + '"]');
        if (keep) keep.focus();
      } else if (chip && !chip.disabled) {
        this.state.pieceVariantId = chip.getAttribute('data-piece-variant');
        this.querySelector('[data-alert]').textContent = '';
        this.render();
        var keepChip = this.querySelector('[data-piece-variant="' + this.state.pieceVariantId + '"]');
        if (keepChip) keepChip.focus();
      } else if (cta) {
        this.submit(cta);
      }
    }

    submit(cta) {
      if (mutation.pending) return;
      var alertEl = this.querySelector('[data-alert]');
      alertEl.textContent = '';
      if (mutation.lastOutcome) mutation.lastOutcome.dismissed = true;
      var copy = this.config.copy || {};
      var pant = this.pantUnit();
      var piece = this.piece();
      if (!piece) return;
      if (!pant || !pant.chosen) {
        alertEl.textContent = copy.needPantSize;
        if (this.form && typeof this.form.validate === 'function') this.form.validate();
        return;
      }
      var chosenId = String(this.state.pieceVariantId);
      var pv = piece.variants.find(function (v) { return String(v.id) === chosenId; });
      if (!pv) {
        alertEl.textContent = fill(copy.needPieceSize, { piece: piece.shortTitle });
        var group = this.querySelector('[data-piece-sizes]');
        if (group) group.setAttribute('aria-describedby', alertEl.id || '');
        var first = this.querySelector('[data-piece-variant]:not([disabled])');
        if (first) first.focus();
        return;
      }
      var titleEl = document.querySelector('.section-main-product .pdp-v2 h1.product-title');
      var items = [
        { variantId: pant.id, price: pant.price, compareAt: pant.compareAt, title: this.config.title || (titleEl ? titleEl.textContent.trim() : ''), productId: this.config.productId, url: location.pathname, image: this.config.image || '', vendor: this.config.vendor || '', type: this.config.type || '' },
        { variantId: pv.id, price: pv.price, compareAt: pv.compareAt, title: piece.title, productId: piece.id, url: piece.url, image: piece.image || '', vendor: piece.vendor, type: piece.type }
      ];
      var self = this;
      this.setBusy(true);
      api.addSet({ items: items, currency: this.config.currency, copy: copy, opener: cta })
        .then(function (outcome) { self.setBusy(false); self.finish(outcome); });
    }

    finish(outcome) {
      if (!outcome || !this._connected) return;
      var copy = this.config.copy || {};
      if (outcome.kind === 'confirmed') {
        this.state.pieceId = null;
        this.state.pieceVariantId = null;
        var live = this.querySelector('[data-live]');
        if (live) live.textContent = copy.added;
      }
      this.render();
    }

    setBusy(on) {
      var cta = this.querySelector('[data-cta]');
      if (!cta) return;
      cta.disabled = !!on;
      if (on) cta.setAttribute('aria-busy', 'true'); else cta.removeAttribute('aria-busy');
    }

    quoteFor(co, offer, cartLines, pant, unit) {
      // §8.2: before the first state publication the bag is unknown, not empty:
      // full prices only, no qualification claims.
      if (!this.known) {
        return { unknown: true, qualified: false, rows: [{ net: pant.price }, { net: unit.price }], total: pant.price + unit.price, was: null, save: 0, bagDrops: false };
      }
      return api.setQuote(co, offer, cartLines, [{ price: pant.price, compareAt: pant.compareAt }, { price: unit.price, compareAt: unit.compareAt }]);
    }

    render() {
      var co = coApi();
      if (!co || !this.config) return;
      var copy = this.config.copy || {};
      var offer = this.offer();
      var st = typeof co.getState === 'function' ? co.getState() : { loaded: false };
      this.known = !!(st && st.loaded && st.cart && Array.isArray(st.cart.lines));
      var cartLines = this.known ? st.cart.lines : [];
      var pant = this.pantUnit();
      var pieces = this.config.pieces || [];
      var self = this;

      this.querySelectorAll('[data-tab]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-tab') === self.state.tab));
      });
      this.querySelectorAll('[data-tiles]').forEach(function (list) {
        list.hidden = list.getAttribute('data-tiles') !== self.state.tab;
      });
      this.querySelectorAll('.pdp-v2-set__tile').forEach(function (tile) {
        var p = pieces.find(function (x) { return String(x.id) === tile.getAttribute('data-piece'); });
        if (!p) return;
        tile.setAttribute('aria-pressed', String(String(self.state.pieceId) === String(p.id)));
        var v = p.variants.find(function (x) { return x.available; }) || p.variants[0];
        if (!pant || !v) return;
        var q = self.quoteFor(co, offer, cartLines, pant, v);
        var price = q.qualified ? self.money(q.rows[1].net) + ' ' + copy.inASet : self.money(v.price);
        tile.setAttribute('aria-label', p.shortTitle + ', ' + (p.colour || '') + ', ' + price);
      });

      var piece = this.piece();
      var summary = this.querySelector('[data-summary]');
      var picked = this.querySelector('[data-picked]');
      if (summary) summary.hidden = !!piece;
      if (picked) picked.hidden = !piece;

      var foldedSub = this.querySelector('[data-folded-sub]');
      if (foldedSub && pant) {
        var tabPieces = pieces.filter(function (x) { return x.tab === self.state.tab; });
        var probePiece = tabPieces[0];
        var probe = probePiece ? (probePiece.variants.find(function (x) { return x.available; }) || probePiece.variants[0]) : null;
        var q0 = probe ? this.quoteFor(co, offer, cartLines, pant, probe) : null;
        if (q0 && !q0.qualified && !q0.unknown) {
          foldedSub.textContent = fill(copy.notQualified, { remaining: q0.remaining, collection: this.config.collection, percentage: offer.percentage, min: offer.min });
        } else {
          var base = this.state.tab === 'tops' ? copy.foldedTops : copy.foldedColours;
          if (this.state.tab === 'tops' && q0 && q0.qualified) {
            var nets = tabPieces.map(function (x) {
              var v2 = x.variants.find(function (y) { return y.available; });
              return v2 ? self.quoteFor(co, offer, cartLines, pant, v2).rows[1].net : Infinity;
            });
            var from = Math.min.apply(null, nets);
            if (isFinite(from)) base = base + ' ' + copy.fromPrefix + ' ' + this.money(from) + '.';
          }
          foldedSub.textContent = base;
        }
      }

      if (!piece || !pant) { this.renderNote(co, offer, cartLines, pant, null); return; }

      var chosenId = String(this.state.pieceVariantId);
      var pv = piece.variants.find(function (x) { return String(x.id) === chosenId; }) || null;
      var unit = pv || piece.variants.find(function (x) { return x.available; }) || piece.variants[0];
      var quote = this.quoteFor(co, offer, cartLines, pant, unit);

      var info = this.querySelector('[data-piece-info]');
      info.textContent = '';
      var name = document.createElement('span'); name.className = 'pdp-v2-set__name'; name.textContent = piece.shortTitle; info.appendChild(name);
      var meta = document.createElement('span'); meta.className = 'pdp-v2-set__meta'; meta.textContent = piece.colour || ''; info.appendChild(meta);
      var pr = document.createElement('span'); pr.className = 'pdp-v2-set__price';
      if (quote.qualified) {
        var now = document.createElement('span'); now.className = 'pdp-v2-set__now'; now.textContent = this.money(quote.rows[1].net) + ' ' + copy.inASet;
        var rrp = document.createElement('s'); rrp.textContent = this.money(quote.rows[1].full);
        pr.appendChild(now); pr.appendChild(document.createTextNode(' ')); pr.appendChild(rrp);
      } else {
        pr.textContent = this.money(unit.price);
      }
      info.appendChild(pr);

      var sizes = this.querySelector('[data-piece-sizes]');
      // §8.11: a rebuild (e.g. on a state event) keeps keyboard focus on the same chip,
      // else on the first available one.
      var act = document.activeElement;
      var hadFocus = !!act && sizes.contains(act) && act.getAttribute('data-piece-variant');
      sizes.textContent = '';
      var labelId = 'pdp-v2-set-size-' + piece.id;
      var lab = document.createElement('span'); lab.id = labelId; lab.className = 'pdp-v2-set__size-label';
      lab.textContent = fill(copy.pieceSizeLabel, { piece: piece.shortTitle }) + ' — ' + (pv ? pv.short || pv.title : copy.selectPlaceholder);
      sizes.appendChild(lab);
      sizes.setAttribute('aria-labelledby', labelId);
      var grid = document.createElement('div'); grid.className = 'pdp-v2-set__chips';
      piece.variants.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pdp-v2-set__chip';
        b.setAttribute('data-piece-variant', v.id);
        b.setAttribute('aria-pressed', String(!!pv && String(pv.id) === String(v.id)));
        var nm = v.short || v.option || v.title;
        b.innerHTML = '<span class="js-value"></span>' + (v.au ? '<span class="opt-label__au">AU ' + v.au + '</span>' : '');
        b.firstChild.textContent = nm;
        b.setAttribute('aria-label', nm + (v.au ? ', AU ' + v.au : '') + (v.available ? '' : ', ' + copy.soldOut));
        if (!v.available) b.disabled = true;
        grid.appendChild(b);
      });
      sizes.appendChild(grid);
      if (hadFocus) {
        var back = grid.querySelector('[data-piece-variant="' + hadFocus + '"]:not([disabled])') || grid.querySelector('[data-piece-variant]:not([disabled])');
        if (back) back.focus();
      }

      var totals = this.querySelector('[data-totals]');
      totals.textContent = '';
      if (quote.qualified) {
        var was = document.createElement('s'); was.textContent = this.money(quote.was);
        var save = document.createElement('span'); save.className = 'pdp-v2-set__save'; save.textContent = copy.save + ' ' + this.money(quote.save);
        totals.appendChild(was);
        totals.appendChild(document.createTextNode(' ' + this.money(quote.total) + ' '));
        totals.appendChild(save);
      } else {
        totals.textContent = this.money(quote.total);
      }
      var cta = this.querySelector('[data-cta]');
      if (cta && !cta.hasAttribute('aria-busy')) cta.textContent = copy.cta + ' — ' + this.money(quote.total);
      this.renderNote(co, offer, cartLines, pant, quote);
    }

    renderNote(co, offer, cartLines, pant, quote) {
      var copy = this.config.copy || {};
      var note = this.querySelector('[data-note]');
      var alertEl = this.querySelector('[data-alert]');
      if (alertEl && mutation.lastOutcome && mutation.lastOutcome.kind === 'unproven' && !mutation.lastOutcome.dismissed) {
        alertEl.textContent = mutation.lastOutcome.message;
      }
      if (!note || !pant) return;
      var lines = [];
      if (!this.known) { note.textContent = ''; note.hidden = true; return; }
      if (quote && !quote.qualified) {
        lines.push(fill(copy.notQualified, { remaining: quote.remaining, collection: this.config.collection, percentage: offer.percentage, min: offer.min }));
      }
      if (quote && quote.bagDrops) lines.push(copy.bagDrops);
      var pq = api.pantQuote(co, offer, cartLines, pant);
      if (pq.bagQualifies && pq.saving > 0) lines.push(fill(copy.bagThisPant, { price: this.money(pq.setPrice) }));
      note.textContent = lines.join(' ');
      note.hidden = lines.length === 0;
    }

    /** M16 (S2): "Make it a set" link above the sticky buttons, v2 only. */
    injectStickyLink() {
      var section = this.closest('.section-main-product');
      var sticky = section ? section.querySelector('sticky-atc') : null;
      if (!sticky || sticky.querySelector('.pdp-v2-sticky-set')) return;
      var copy = this.config.copy || {};
      var text = Number(this.config.min) === 2 ? copy.stickyBoth : copy.stickyMin;
      if (!text) return;
      var a = document.createElement('a');
      a.className = 'pdp-v2-sticky-set';
      a.href = '#set';
      a.textContent = fill(text, { percentage: this.config.percentage, min: this.config.min });
      // Before the phone size button, if mounted: tab order = visual order.
      var buttons = sticky.querySelector('.pdp-v2-sticky-size') || sticky.querySelector('.sticky-atc__buttons');
      if (buttons && buttons.parentNode) buttons.parentNode.insertBefore(a, buttons); else sticky.appendChild(a);
      this.stickyLink = a;
    }
  }

  // ---- M4 (S2): the set price line under the price ----
  class PdpSetPrice extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this.config = api.readIsland(this, 'script[data-set-price]') || {};
      this.form = this.closest('product-form');
      this._onRender = this.render.bind(this);
      document.addEventListener('on:collection-offer:state', this._onRender);
      if (this.form) this.form.addEventListener('on:variant:change', this._onRender);
      this.render();
    }

    disconnectedCallback() {
      if (!this._connected) return;
      this._connected = false;
      document.removeEventListener('on:collection-offer:state', this._onRender);
      if (this.form) this.form.removeEventListener('on:variant:change', this._onRender);
    }

    render() {
      var co = coApi();
      var text = this.querySelector('[data-set-price-text]');
      var injected = api.isInjected(this);
      var row = document.querySelector('.section-main-product pdp-set-row');
      if (!co || !text || (!row && !injected)) { this.hidden = true; return; }
      var picker = this.form && this.form.querySelector('variant-picker');
      var data = picker && typeof picker.getVariantData === 'function' ? picker.getVariantData() : null;
      var v = (picker && picker.variant) || ((data && data.variants) || []).find(function (x) { return x.available; });
      if (!v) { this.hidden = true; return; }
      var offer = { slot: Number(this.config.slot), percentage: Number(this.config.percentage), min: Number(this.config.min) };
      var st = typeof co.getState === 'function' ? co.getState() : { loaded: false };
      var lines = st && st.loaded && st.cart && Array.isArray(st.cart.lines) ? st.cart.lines : [];
      var q = api.pantQuote(co, offer, lines, { price: v.price, compareAt: v.compare_at_price || 0 });
      if (q.saving <= 0) { this.hidden = true; return; }
      text.textContent = fill(this.config.template, {
        price: theme.formatMoney(q.setPrice, { currency: this.config.currency }),
        min: offer.min,
        percentage: offer.percentage
      });
      this.hidden = false;
    }
  }

  if (!customElements.get('pdp-set-row')) customElements.define('pdp-set-row', PdpSetRow);
  if (!customElements.get('pdp-set-price')) customElements.define('pdp-set-price', PdpSetPrice);
})();
